(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const isEscape = (event) => String(event.key || '').toLowerCase().startsWith('esc') || event.code === 'Escape' || event.keyCode === 27 || event.which === 27;
  let activeLayer = null;
  let returnFocus = null;
  let cartCurrency = document.body.dataset.currency || '';
  const approvedVisuals = (() => {
    try { return JSON.parse(document.querySelector('[data-approved-visual-map]')?.textContent || '{}'); }
    catch { return {}; }
  })();

  function formatMoney(cents, currency = cartCurrency) {
    if (!currency) return (Number(cents) / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    } catch {
      return String((Number(cents) / 100).toFixed(2)) + ' ' + currency;
    }
  }

  function openLayer(layer, trigger) {
    if (!layer) return;
    returnFocus = trigger || document.activeElement;
    activeLayer = layer;
    layer.setAttribute('aria-hidden', 'false');
    layer.setAttribute('aria-busy', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
    $(focusable, layer)?.focus();
  }

  function closeLayer(layer) {
    if (!layer) return;
    layer.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + layer.id + '"]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('no-scroll');
    activeLayer = null;
    returnFocus?.focus();
  }

  document.addEventListener('keydown', (event) => {
    if (!isEscape(event)) return;
    const navigation = $('.nav-menu[open]');
    if (!navigation) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigation.open = false;
    $('summary', navigation)?.focus();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!activeLayer) return;
    if (isEscape(event)) {
      event.preventDefault();
      closeLayer(activeLayer);
      return;
    }
    if (event.key !== 'Tab') return;
    const items = $$(focusable, activeLayer);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const menu = $('[data-mobile-menu]');
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav-menu')) $$('.nav-menu[open]').forEach((details) => details.removeAttribute('open'));
    const openMenu = event.target.closest('[data-menu-open]');
    if (openMenu) openLayer(menu, openMenu);
    if (event.target.closest('[data-menu-close]')) closeLayer(menu);
  });

  const drawer = $('[data-cart-drawer]');
  const cartStatus = (message) => {
    const target = $('[data-cart-status]', drawer);
    if (target) target.textContent = message || '';
  };

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function safeStoreUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : (document.body.dataset.rootUrl || '/');
    } catch {
      return document.body.dataset.rootUrl || '/';
    }
  }

  function safeImageUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch {
      return '';
    }
  }

  function quantityControl(item, displayTitle = item.product_title) {
    const wrap = element('div', 'quantity-control');
    const minus = element('button', '', '−');
    minus.type = 'button';
    minus.dataset.cartQuantity = item.key;
    minus.dataset.value = Math.max(0, item.quantity - 1);
    minus.setAttribute('aria-label', drawer.dataset.decreaseLabel + ' ' + displayTitle);
    const label = element('label', 'visually-hidden', drawer.dataset.quantityLabel + ' ' + displayTitle);
    const input = element('input');
    input.id = 'CartDrawerQuantity-' + item.key.replace(/[^a-zA-Z0-9_-]/g, '');
    label.htmlFor = input.id;
    input.type = 'number';
    input.min = '0';
    input.value = String(item.quantity);
    input.inputMode = 'numeric';
    input.dataset.cartInput = item.key;
    const plus = element('button', '', '+');
    plus.type = 'button';
    plus.dataset.cartQuantity = item.key;
    plus.dataset.value = item.quantity + 1;
    plus.setAttribute('aria-label', drawer.dataset.increaseLabel + ' ' + displayTitle);
    wrap.append(minus, label, input, plus);
    return wrap;
  }

  function renderCart(cart) {
    cartCurrency = cart.currency || cartCurrency;
    const itemsRoot = $('[data-cart-items]', drawer);
    itemsRoot.replaceChildren();
    if (!cart.items.length) {
      itemsRoot.append(element('p', 'empty-state', drawer.dataset.emptyLabel));
    } else {
      cart.items.forEach((item) => {
        const row = element('article', 'cart-line');
        const mediaLink = element('a');
        mediaLink.href = safeStoreUrl(item.url);
        const approvedVisual = approvedVisuals[String(item.product_id)];
        const displayTitle = approvedVisual?.title || item.product_title;
        const imageUrl = safeImageUrl(approvedVisual?.image || item.image);
        if (imageUrl) {
          const image = element('img');
          image.src = imageUrl;
          image.alt = displayTitle;
          image.width = 80;
          image.height = 96;
          image.loading = 'lazy';
          mediaLink.append(image);
        }
        const copy = element('div', 'cart-line-copy');
        const title = element('a', '', displayTitle);
        title.href = safeStoreUrl(item.url);
        copy.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') copy.append(element('small', '', item.variant_title));
        copy.append(element('small', '', formatMoney(item.final_line_price, cart.currency)));
        const remove = element('button', 'text-button', drawer.dataset.removeLabel);
        remove.type = 'button';
        remove.dataset.cartQuantity = item.key;
        remove.dataset.value = '0';
        copy.append(remove);
        row.append(mediaLink, copy, quantityControl(item, displayTitle));
        itemsRoot.append(row);
      });
    }
    $$('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price, cart.currency);
    $('[data-cart-checkout]', drawer).disabled = cart.item_count === 0;
  }

  async function cartRequest(url, options) {
    drawer.classList.add('is-loading');
    drawer.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, options);
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || drawer.dataset.errorLabel);
      return payload;
    } finally {
      drawer.classList.remove('is-loading');
      drawer.setAttribute('aria-busy', 'false');
    }
  }

  async function loadCart() {
    try {
      renderCart(await cartRequest(drawer.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } }));
    } catch (error) {
      cartStatus(error.message || drawer.dataset.errorLabel);
    }
  }

  async function changeCart(key, quantity) {
    cartStatus('');
    try {
      const cart = await cartRequest(drawer.dataset.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Math.floor(Number(quantity) || 0)) })
      });
      renderCart(cart);
      cartStatus(drawer.dataset.updatedLabel);
    } catch (error) {
      cartStatus(error.message || drawer.dataset.errorLabel);
      await loadCart();
    }
  }

  document.addEventListener('click', (event) => {
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) {
      openLayer(drawer, cartOpen);
      loadCart();
    }
    if (event.target.closest('[data-cart-close]')) closeLayer(drawer);
    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) changeCart(quantityButton.dataset.cartQuantity, quantityButton.dataset.value);
    const productQuantityButton = event.target.closest('[data-quantity-minus],[data-quantity-plus]');
    if (productQuantityButton) {
      const form = productQuantityButton.closest('form');
      const input = $('[data-product-quantity]', form);
      const delta = productQuantityButton.matches('[data-quantity-plus]') ? 1 : -1;
      input.value = String(Math.max(1, (Number(input.value) || 1) + delta));
    }
    const mediaButton = event.target.closest('[data-media-button]');
    if (mediaButton) {
      const gallery = mediaButton.closest('[data-product-gallery]');
      $$('[data-product-media]', gallery).forEach((media) => media.classList.toggle('is-hidden', media.dataset.productMedia !== mediaButton.dataset.mediaButton));
      $$('[data-media-button]', gallery).forEach((button) => button.setAttribute('aria-current', button === mediaButton ? 'true' : 'false'));
    }
    const mobileSubmit = event.target.closest('[data-mobile-submit]');
    if (mobileSubmit) document.getElementById(mobileSubmit.dataset.formId)?.requestSubmit();
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-input]')) changeCart(event.target.dataset.cartInput, event.target.value);
    if (event.target.matches('[data-sort-select]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-language-select]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target.closest('[data-product-root]'));
  });

  function variantsFor(root) {
    const script = $('[data-product-variants]', root?.parentElement || document) || $('[data-product-variants]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch { return []; }
  }

  function updateVariant(root) {
    if (!root) return;
    const select = $('[data-variant-select]', root);
    const variant = variantsFor(root).find((item) => String(item.id) === String(select.value));
    if (!variant) return;
    $('[data-product-price]', root).textContent = variant.price_formatted;
    const compare = $('[data-compare-price]', root);
    compare.hidden = !(variant.compare_at_price > variant.price);
    compare.textContent = compare.hidden ? '' : variant.compare_at_price_formatted;
    const submit = $('[data-product-submit]', root);
    submit.disabled = !variant.available;
    $('[data-submit-label]', root).textContent = variant.available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
    const mobile = $('[data-mobile-buy]');
    if (mobile) {
      $('[data-mobile-price]', mobile).textContent = variant.price_formatted;
      const button = $('[data-mobile-submit]', mobile);
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
    }
    if (variant.featured_media_id) $('[data-media-button="' + variant.featured_media_id + '"]', root)?.click();
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.matches('[data-product-form]')) {
      event.preventDefault();
      const errorNode = $('[data-product-error]', form);
      const statusNode = $('[data-product-status]', form);
      const button = $('[data-product-submit]', form);
      errorNode.hidden = true;
      errorNode.textContent = '';
      statusNode.textContent = button.dataset.loadingLabel;
      button.disabled = true;
      try {
        await cartRequest(drawer.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        statusNode.textContent = '';
        openLayer(drawer, button);
        await loadCart();
        cartStatus(drawer.dataset.addedLabel);
      } catch (error) {
        errorNode.textContent = error.message || drawer.dataset.errorLabel;
        errorNode.hidden = false;
        statusNode.textContent = '';
      } finally {
        updateVariant(form.closest('[data-product-root]'));
      }
    }

    if (form.matches('[data-finder-form]')) {
      event.preventDefault();
      const values = new FormData(form);
      const section = form.closest('.finder');
      const result = $('[data-finder-result]', section);
      const template = $$('template[data-finder-config]', section).find((item) => item.dataset.concern === values.get('goal'));
      const configured = template ? $$('a', template.content) : [];
      const selected = configured.filter((link) => {
        if (link.hasAttribute('data-eye')) return values.get('eye') === 'yes';
        return values.get('routine') === 'complete' || link.hasAttribute('data-essential');
      });
      result.replaceChildren(element('strong', '', result.dataset.heading));
      if (!selected.length) {
        result.append(element('p', '', result.dataset.empty));
      } else {
        const list = element('div', 'finder-links');
        selected.forEach((link) => {
          const clone = link.cloneNode(true);
          const role = element('small', '', link.dataset.role);
          clone.prepend(role);
          list.append(clone);
        });
        result.append(list, element('small', '', result.dataset.disclaimer));
      }
      result.hidden = false;
      result.focus({ preventScroll: false });
    }
  });

  function loadRecommendations(root = document) {
    $$('[data-product-recommendations]', root).forEach((container) => {
      if (container.dataset.loaded === 'true') return;
      container.dataset.loaded = 'true';
      fetch(container.dataset.url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const replacement = $('[data-product-recommendations]', doc);
          if (replacement?.childElementCount) container.replaceChildren(...Array.from(replacement.childNodes));
          else container.hidden = true;
        })
        .catch(() => { container.hidden = true; });
    });
  }

  document.addEventListener('shopify:section:load', (event) => loadRecommendations(event.target));
  loadRecommendations();
})();
